var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBlocked = function SvgBlocked(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    width: "150px",
    height: "200px",
    viewBox: "0 0 150 200",
    enableBackground: "new 0 0 150 200",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#010101",
    d: "M58.3,133.3c0-9.2,7.5-16.7,16.7-16.7s16.7,7.5,16.7,16.7c0,6.2-3.4,11.5-8.3,14.4v19H66.7v-19 C61.7,144.8,58.3,139.5,58.3,133.3z M150,83.3V200H0V83.3h25V50C25,22.4,47.4,0,75,0s50,22.4,50,50v33.3H150z M41.7,83.3h66.7V50 c0-18.4-15-33.3-33.3-33.3S41.7,31.6,41.7,50V83.3z M133.3,100H16.7v83.3h116.7V100z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBlocked, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/blocked.a3bf979d.svg";
export { ForwardRef as ReactComponent };